// extracted by mini-css-extract-plugin
export default {"root":"CuW5EWd_tCNXwF8ELISV","icon":"th1SmPEJ0HpN3VSS3aQz","head":"sqteMOBSX469vw7xcjka","text":"YPbBt931VyseLIbQrn_7","placeHolderShimmer":"aQS938uTAnTGJxlWprtf"};